import React from 'react'
import { jt, t } from 'ttag'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { createPortal } from 'react-dom'
import { withRouter } from 'react-router-dom'

import { clearComparison, compareOccupations } from '../actions/occupationProfile'
import OccupationComparison from '../containers/occupations/OccupationComparison'
import * as h2Api from '../h2Api'
import { browserHistory } from '../Routes'
import { clearInstitutionComparison, compareInstitutions } from '../actions/colleges'
import { CollegeComparison } from '../containers/colleges/CollegeComparison'
import { MajorComparison } from '../containers/colleges/MajorComparison'
import { clearMajorComparison, compareMajors } from '../actions/majors'
import { clearJobComparison, compareJobs } from '../actions/jobsearch'
import { JobOpeningComparison } from '../containers/jobs/JobOpeningComparison'
import {
  clearMilitaryOccupationComparison,
  compareMilitaryOccupation
} from '../actions/military'
import { MilitaryOccupationComparison } from '../containers/military/MilitaryOccupationComparison'
import { useQuery } from '../util/hooks'
import 'url-search-params-polyfill'

const ComparisonFooter = ({
  selected,
  comparisonResponse,
  onClearComparison,
  onCompare,
  dispatch,
  Component
}) => {
  const params = useQuery()
  const showModal = !!Object.keys(params)?.includes('comp')
  const values = {
    0: t`no`,
    1: t`one`,
    2: t`two`,
    3: t`three`,
    4: t`four`
  }
  const numSelected = <b key="numselected">{values[selected.length]}</b>
  const numRemaining = <b key="numremaining">{values[4 - selected.length]}</b>
  const closeModal = async () => {
    await dispatch(onClearComparison())
    const searchHeader = window.location.search?.substring(1)
    const qsParams = new URLSearchParams(searchHeader)

    qsParams.delete('comp')
    const url = window.location.pathname

    return browserHistory.replace(
      `${url}${qsParams.toString().length > 1 ? `?${qsParams.toString()}` : ''}`
    )
  }
  const compareAndOpenModal = async selectedOcc => {
    //  console.log(selected)
    await dispatch(onCompare(selectedOcc))
    const searchHeader = window.location.search?.substring(1)
    const qsParams = new URLSearchParams(searchHeader)

    if (!qsParams.has('comp')) {
      qsParams.append('comp', 'true')
    }

    const url = window.location.pathname

    return browserHistory.replace(
      `${url}${qsParams.toString().length > 1 ? `?${qsParams.toString()}` : ''}`
    )
  }

  /*
   * console.log("ITEMS SELECTED", selected)
   *    console.log("RSP", comparisonResponse)
   */
  return [
    createPortal(
      <div id="comparewrap" className={selected.length > 0 ? 'visible' : 'notvisible'}>
        {selected.length === 0 ? null : (
          <div className="container">
            <form
              id="tempcomparebutton"
              onSubmit={e => {
                e.preventDefault()
                compareAndOpenModal(selected)
              }}>
              <button type="submit" className="btn btn-success">
                {t`Compare Selected`}{' '}
                {!h2Api.receivedResponse(comparisonResponse) &&
                comparisonResponse?.loading ? (
                  <i className="fal fa-circle-notch fa-spin"></i>
                ) : null}{' '}
              </button>
              <div
                id="instr"
                style={{
                  display: 'inline-block'
                }}>
                {jt`You have selected ${numSelected} items to compare, you can select ${numRemaining} more.`}
              </div>
            </form>
          </div>
        )}
      </div>,
      document.getElementsByTagName('body')[0]
    ),
    <Modal
      bsSize="large"
      key="comparisonModal"
      backdrop="static"
      className="compareClass"
      show={!!showModal && h2Api.isSuccess(comparisonResponse)}
      onHide={closeModal}>
      <Modal.Header style={{ color: 'white', fontWeight: 'bold' }} closeButton>
        <h2>{t`Comparison`}</h2>
      </Modal.Header>
      <Modal.Body>
        <Component fluidContainer={true} />
      </Modal.Body>
    </Modal>
  ]
}

export default connect(
  (state, ownProps) => {
    const defaultProps = {
      compareType: ownProps.compareType
    }
    /*
     * console.log("SEARCH COMPARE", searchHeader, ownProps, params, defaultProps)
     *  console.log("STATE", ownProps.compareType, state.jobs.comparison)
     */
    const generateComparison = () => {
      switch (ownProps.compareType) {
        case 'college':
          return {
            onCompare: compareInstitutions,
            onClearComparison: clearInstitutionComparison,
            Component: CollegeComparison,
            selected: state.college.comparison.selectedInstitutions,
            comparisonResponse: state.college.collegeComparison
          }
        case 'major':
          return {
            onCompare: compareMajors,
            onClearComparison: clearMajorComparison,
            Component: MajorComparison,
            selected: state.college.majorComparisonItems.selectedMajors,
            comparisonResponse: state.college.majorComparison
          }
        case 'joborders':
          return {
            onCompare: compareJobs,
            onClearComparison: clearJobComparison,
            Component: JobOpeningComparison,
            selected: state.jobs.comparison.selected,
            comparisonResponse: state.jobs.comparisonResponse
          }
        case 'moc':
          return {
            onCompare: compareMilitaryOccupation,
            onClearComparison: clearMilitaryOccupationComparison,
            Component: MilitaryOccupationComparison,
            selected: state.military.comparison.selected,
            comparisonResponse: state.military.comparisonResponse
          }
        default:
          return {
            onCompare: compareOccupations,
            onClearComparison: clearComparison,
            Component: OccupationComparison,
            selected: state.occupations.comparison.selectedOccupations,
            comparisonResponse: state.occupations.comparisonResponse
          }
      }
    }

    return {
      ...defaultProps,
      ...generateComparison()
    }
  },
  dispatch => ({
    dispatch
  })
)(withRouter(ComparisonFooter))
